import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { HelpCircle } from "lucide-react";
import { FAQS } from "../mock/data";

const FAQSection = () => {
  return (
    <section id="faqs" className="py-24 lg:py-32 bg-[#07070A]">
      <div className="max-w-[1180px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <div className="sticky top-28">
              <div className="inline-flex items-center gap-2 mb-6">
                <HelpCircle className="w-4 h-4 text-[#14E0BF]" />
                <span className="font-mono text-[11px] text-[#14E0BF] uppercase tracking-[0.2em]">
                  Common Questions
                </span>
              </div>
              <h2 className="text-white mb-6">
                <span className="font-serif-display italic text-5xl lg:text-6xl leading-[0.95] block">
                  Before you
                </span>
                <span className="font-display text-5xl lg:text-6xl leading-[0.95] block mt-1">
                  APPLY.
                </span>
              </h2>
              <p className="text-white/65 text-base leading-relaxed mb-8">
                Most partners ask the same questions. Here are the straight answers – no franchise-speak.
              </p>
              <a
                href="#journey"
                className="btn-pill inline-flex items-center gap-2 bg-[#14E0BF] hover:bg-[#0FB89C] text-[#07070A] font-display text-[12px] uppercase tracking-wider px-5 py-3 rounded-full"
              >
                Start Application →
              </a>
            </div>
          </div>

          <div className="lg:col-span-8">
            <Accordion
              type="single"
              collapsible
              defaultValue="item-1"
              className="space-y-3"
            >
              {FAQS.map((f) => (
                <AccordionItem
                  key={f.id}
                  value={`item-${f.id}`}
                  className="bg-[#14141B] border border-white/10 rounded-2xl px-6 data-[state=open]:border-[#14E0BF]/40 transition-all"
                >
                  <AccordionTrigger className="font-display text-left text-white text-base lg:text-lg uppercase py-5 hover:no-underline hover:text-[#14E0BF] transition-colors [&[data-state=open]]:text-[#14E0BF] gap-4">
                    <div className="flex items-center gap-4">
                      <span className="font-mono text-[11px] text-white/35 shrink-0">
                        {String(f.id).padStart(2, "0")}
                      </span>
                      <span>{f.question}</span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="text-white/70 text-[15px] leading-relaxed pb-5 pl-12 pr-2">
                    {f.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
